import React from 'react';

const SidebarConsultantInfo = ({ assignedEmployees }) => {
    if (!assignedEmployees || assignedEmployees.length === 0) return null;

    return (
        <div className="mb-4">
            <h6 className="text-uppercase font-size-11 fw-bold text-brand-secondary mb-2">
                <i className="mdi mdi-account-tie-outline me-1"></i>
                {assignedEmployees.length > 1 ? 'Consultores Responsáveis' : 'Consultor Responsável'}
            </h6>
            <div className="d-flex flex-wrap gap-2">
                {assignedEmployees.map((emp, idx) => (
                    <div key={emp.id || idx} className="d-flex align-items-center gap-2 px-3 py-1.5 bg-white border rounded-3 shadow-sm">
                        <div style={{ width: '24px', height: '24px', flexShrink: 0 }}>
                            {emp.photoUrl ? (
                                <img 
                                    src={emp.photoUrl} 
                                    alt="Consultor" 
                                    className="rounded-circle" 
                                    style={{ width: '24px', height: '24px', objectFit: 'cover' }} 
                                />
                            ) : (
                                <div 
                                    className="rounded-circle d-flex align-items-center justify-content-center bg-light border font-size-10 fw-bold text-brand-primary" 
                                    style={{ width: '24px', height: '24px' }}
                                >
                                    {(emp.name?.charAt(0) || 'R').toUpperCase()}
                                </div>
                            )}
                        </div>
                        <span className="font-size-12 fw-bold text-brand-primary">
                            {emp.name || 'Consultor'}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SidebarConsultantInfo;
